import { TextBlockGridComponent } from './TextBlockGrid';
export default TextBlockGridComponent;
